
import { defineComponent, onMounted } from 'vue';
import { AppCard, AppTable, AppButton } from '@/components';
import { useStarterPackList } from '@/modules/starter/pack/model/list';
import { ROUTE_NAME_STARTER } from '@/modules/starter/pack/router';
import { TableColumnType, TableConfig } from '@/components/table/types';

export default defineComponent({
    name: ROUTE_NAME_STARTER.PACK.INDEX,
    components: { AppTable, AppButton, AppCard },
    setup() {
        const { list, total, fetchList, actions } = useStarterPackList();

        const table: TableConfig = {
            columns: [
                { type: TableColumnType.Text, label: 'ID', key: 'id' },
                { type: TableColumnType.Text, label: 'Name', key: 'name' },
                { type: TableColumnType.Text, label: 'Package', key: 'packageId' },
                { type: TableColumnType.Text, label: 'Price', key: 'price' },
                { type: TableColumnType.Text, label: 'Amount', key: 'amount' },
                { type: TableColumnType.Text, label: 'Duration Seconds', key: 'durationSeconds' },
                { type: TableColumnType.Boolean, label: 'Is Default', key: 'isDefault' },
                { type: TableColumnType.Boolean, label: 'Is Enabled', key: 'isEnabled' },
                { type: TableColumnType.Image, label: 'Image', imageKey: 'image', statusKey: 'imageStatus' },
                { type: TableColumnType.Actions, label: 'Actions' }
            ],
            actions: [
                {
                    props: (row: any) => ({
                        icon: 'fa-gift',
                        theme: 'info',
                        tooltip: 'View rewards',
                        to: { name: ROUTE_NAME_STARTER.PACK.REWARD.INDEX, params: { starterPackId: row.id } }
                    }),
                    group: 0
                },
                {
                    props: (row: any) => ({
                        icon: 'fa-eye',
                        theme: 'info',
                        tooltip: 'Detail',
                        to: { name: ROUTE_NAME_STARTER.PACK.DETAIL, params: { id: row.id } }
                    }),
                    group: 0
                },
                {
                    props: (row: any) => ({
                        icon: 'fa-edit',
                        theme: 'info',
                        tooltip: 'Edit',
                        to: { name: ROUTE_NAME_STARTER.PACK.EDIT, params: { id: row.id } }
                    }),
                    canShow: (row: any) => row.canEdit,
                    group: 0
                },
                {
                    props: (row: any) => ({
                        icon: 'fa-play',
                        theme: 'success',
                        tooltip: 'Enable',
                        onClick: () => actions.enable(row.id)
                    }),
                    canShow: (row: any) => row.canEnable,
                    group: 1
                },
                {
                    props: (row: any) => ({
                        icon: 'fa-stop',
                        theme: 'warning',
                        tooltip: 'Disable',
                        onClick: () => actions.disable(row.id)
                    }),
                    canShow: (row: any) => row.canDisable,
                    group: 1
                },
                {
                    props: (row: any) => ({
                        icon: 'fa-trash-alt',
                        theme: 'danger',
                        tooltip: 'Delete',
                        disabled: !row.canDelete,
                        onClick: () => actions.remove(row.id)
                    })
                }
            ]
        };

        onMounted(fetchList);

        return { table, list, total, fetchList, ROUTE_NAME_STARTER };
    }
});
